import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/stock/${dossierId}/DossierRatingComponent`, method: 'GET', token: token })
}
